<template>
  <div class="seller-list">
    <div class="seller-list-left" v-if="!contract">
      <div class="seller-list-searchForm" v-if="userInfo.roles === 3">
        <span class="searchForm-span">客户账号</span>
        <div class="diy-suffix">
          <el-select id="customer_id" v-model="searchForm.customer_id" placeholder="请选择">
            <el-option v-for="item in customerList" :key="item.id" :label="item.firm_name" :value="item.id"></el-option>
          </el-select>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('customer_id')" />
        </div>
      </div>
      <div class="seller-list-searchForm">
        <span class="searchForm-span">创建人</span>
        <div class="diy-suffix">
          <el-select id="create_uid" v-model="searchForm.create_uid" placeholder="请选择">
            <el-option v-for="item in userList" :key="item.id" :label="item.nick_name" :value="item.id"></el-option>
          </el-select>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('create_uid')" />
        </div>
      </div>
      <div class="seller-list-searchForm" v-if="userInfo.roles !== 3">
        <span class="searchForm-span">认领人</span>
        <div class="diy-suffix">
          <el-select id="claim_uid" v-model="searchForm.claim_uid" placeholder="请选择">
            <el-option v-for="item in userList" :key="item.id" :label="item.nick_name" :value="item.id"></el-option>
          </el-select>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('claim_uid')" />
        </div>
      </div>
      <div class="seller-list-searchForm">
        <span class="searchForm-span">店铺名称</span>
        <div class="diy-suffix">
          <el-input type="text" resize="none" placeholder="请输入" v-model="searchForm.shop_name"></el-input>
        </div>
      </div>
      <div class="seller-list-searchForm">
        <span class="searchForm-span">单号状态</span>
        <div class="diy-suffix">
          <el-select id="status" v-model="searchForm.status" placeholder="请选择">
            <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('status')" />
        </div>
      </div>
      <div class="seller-list-searchForm">
        <span class="searchForm-span">问题类型</span>
        <div class="diy-suffix">
          <el-select id="problem_id" v-model="searchForm.problem_id" placeholder="请选择">
            <el-option v-for="item in problemList" :key="item.id" :label="item.problem_type" :value="item.id"></el-option>
          </el-select>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('problem_id')" />
        </div>
      </div>
      <div class="seller-list-searchForm">
        <span class="searchForm-span">导入单号查询</span>
        <el-input type="textarea" :autosize="{minRows: 5,maxRows:5}" resize="none" placeholder="请输入" v-model="searchForm.order_number"></el-input>
      </div>
      <div class="seller-list-searchForm">
        <span class="searchForm-span">查询费用</span>
        <div class="diy-suffix">
          <el-date-picker ref="start_cost_time" id="start_cost_time" v-model="searchForm.start_cost_time" type="datetime" placeholder="选择开始日期" value-format="yyyy-MM-dd HH:mm:ss" />
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('start_cost_time')" />
        </div>
        <div class="diy-suffix">
          <el-date-picker ref="end_cost_time" id="end_cost_time" v-model="searchForm.end_cost_time" type="datetime" placeholder="选择截至日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('end_cost_time')" />
        </div>
      </div>
      <div class="seller-list-searchForm">
        <span class="searchForm-span">新建时间</span>
        <div class="diy-suffix">
          <el-date-picker ref="start_create_time" id="start_create_time" v-model="searchForm.start_create_time" type="datetime" placeholder="选择开始日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('start_create_time')" />
        </div>
        <div class="diy-suffix">
          <el-date-picker ref="end_create_time" id="end_create_time" v-model="searchForm.end_create_time" type="datetime" placeholder="选择截至日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('end_create_time')" />
        </div>
      </div>
      <el-button type="primary" @click="init">搜索</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </div>
    <!-- table部分 -->
    <div class="seller-list-right" :style="contract ? 'width: 100%' : ''">
      <div class="seller-list-right-top">
        <div class="seller-list-rt-btnList">
          <i class="seller-list-open-btn seller-list-icon" :style="`background-image: url(${require(`../../assets/img/${contract ? 'close-btn' : 'open-btn'}.png`)})`" @click="handleContract" />
          <!-- <template v-if="userInfo.roles === 3"> -->
            <el-button class="copy-btn" data-clipboard-action="copy" :data-clipboard-text="copyText" type="primary" @click="copyLink">转单号复制</el-button>
            <el-button class="copy-cus" data-clipboard-action="copy" :data-clipboard-text="copyCustomerText" type="primary" @click="copyCustomer">订单号复制</el-button>
            <el-button class="copy-sku" data-clipboard-action="copy" :data-clipboard-text="copySkuText" type="primary" @click="copySku">型号复制</el-button>
            <el-button type="primary" @click="exportData">导出数据</el-button>
            <el-button type="primary" @click="editShop">修改店铺</el-button>
            <el-button type="primary" @click="batchCheck">批量结单</el-button>
            <el-button type="primary" v-if="userInfo.roles !== 1" @click="reHandle">转批量</el-button>
          <!-- </template> -->
        </div>
        <el-popover placement="bottom" width="160" v-model="visible">
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="(item, i) in tableHeaderList" @change="handleChangeCheckBox" :label="item.label" :key="i"></el-checkbox>
          </el-checkbox-group>
          <i slot="reference" class="seller-list-screen-btn seller-list-icon" />
        </el-popover>
      </div>
      <div class="seller-list-right-table">
        <el-table stripe ref="table" :row-class-name="tableRowClassName" :data="tableData" v-loading="loading" @row-click="handleRowClick" @row-dblclick="toMsg" @selection-change="handleSelectionChange" border style="width: 100%" height="100%">
          <el-table-column type="selection" width="36"></el-table-column>
          <el-table-column v-if="tableHeaderList[8].status" show-overflow-tooltip prop="firm_name" label="客户账号" width="120" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[0].status" show-overflow-tooltip prop="order_number" min-width="180" label="转单号"></el-table-column>
          <el-table-column v-if="tableHeaderList[1].status" show-overflow-tooltip prop="customer_order_number" label="订单号" width="170"></el-table-column>
          <el-table-column v-if="tableHeaderList[2].status" show-overflow-tooltip prop="channel_order_number" label="渠道转单号" width="150"></el-table-column>
          <el-table-column v-if="tableHeaderList[16].status" show-overflow-tooltip prop="sku" label="型号" width="120" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[15].status" prop="shop_name" label="店铺" width="100" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[14].status" show-overflow-tooltip prop="processing_method" label="分类" width="75" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[3].status" show-overflow-tooltip prop="status_text" label="状态" width="75" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[4].status" show-overflow-tooltip prop="problem_type" label="问题类型" width="110" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[5].status" show-overflow-tooltip prop="unreply_num" label="新留言" width="80">
            <template slot-scope="scope">
              {{ userInfo.roles === 3 ? scope.row.unreply_num > 0 ? `${scope.row.unreply_num}条` : '暂无' : scope.row.customer_unreply_num > 0 ? `有${scope.row.customer_unreply_num}条新留言` : '暂无' }}
            </template>
          </el-table-column>
          <el-table-column v-if="tableHeaderList[6].status" show-overflow-tooltip prop="message" label="最新留言内容" width="500">
            <template slot-scope="scope">
              {{ scope.row.message || '暂无' }}
            </template>
          </el-table-column>
          <el-table-column v-if="tableHeaderList[7].status" prop="message_time" label="留言时间" width="160">
            <template slot-scope="scope">
              {{ scope.row.message_time || '暂无' }}
            </template>
          </el-table-column>
          <el-table-column v-if="tableHeaderList[9].status" prop="create_name" label="创建人" width="100" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[10].status" prop="claim_name" label="认领人" width="100" sortable></el-table-column>
          <el-table-column v-if="tableHeaderList[11].status" prop="create_time" label="创建时间" width="160"></el-table-column>
          <el-table-column v-if="tableHeaderList[12].status" prop="cost" label="附加费用" width="80"></el-table-column>
          <el-table-column v-if="tableHeaderList[13].status" show-overflow-tooltip prop="cost_message" label="附加费用说明" width="160">
            <template slot-scope="scope">
              {{ scope.row.cost_message || '暂无' }}
            </template>
          </el-table-column>
          <!-- :fixed="checkList.length > 8 ? 'right' : false"  -->
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <i class="message-icon gongneng-icon" @click="handleMessage(scope.row)" />
              <i class="car-icon gongneng-icon" @click="handleTurnTo(scope.row)" />
              <i class="edit-icon gongneng-icon" @click="handleUpt(scope.row)" />
              <i class="withdraw-icon gongneng-icon" v-if="scope.row.status === 3 && userInfo.id === 8" @click="handleOver(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[50, 100, 200, 500]" :page-size="limit" layout="prev, pager, next, jumper, total, sizes" :total="count"/>
      <el-dialog :visible.sync="dialogVisible" :show-close="false" width="35%" :before-close="handleClose">
        <template slot="title">
          <el-divider content-position="left">{{ dialogTitle }}</el-divider>
        </template>
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="批量分类" prop="processing_method" v-if="dialogTitle === '转批量'">
            <div class="diy-suffix">
              <el-select id="form_processing_method" v-model="form.processing_method" placeholder="请选择">
                <el-option v-for="item in processMethodList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('form_processing_method')" />
            </div>
          </el-form-item>
          <el-form-item label="商店名" v-if="dialogTitle === '修改商店'" prop="shop_name">
            <el-input v-model="form.shop_name"/>
          </el-form-item>
          <el-form-item label="订单号" v-if="dialogTitle === '修改问题件'" prop="customer_order_number">
            <el-input v-model="form.customer_order_number"/>
          </el-form-item>
          <el-form-item label="转单号" v-if="form.uid === 1 && dialogTitle === '修改问题件'" prop="order_number">
            <el-input v-model="form.order_number"/>
          </el-form-item>
          <el-form-item label="渠道转单号" v-if="dialogTitle === '修改问题件'" prop="channel_order_number">
            <el-input v-model="form.channel_order_number"/>
          </el-form-item>
          <el-form-item label="型号" v-if="dialogTitle === '修改问题件'" prop="sku">
            <el-input v-model="form.sku"/>
          </el-form-item>
          <el-form-item label="问题类型" v-if="dialogTitle === '修改问题件'" prop="problem_id">
            <div class="diy-suffix">
              <el-select id="form_problem_id" v-model="form.problem_id" placeholder="请选择">
                <el-option v-for="item in problemList" :key="item.id" :label="item.problem_type" :value="item.id"></el-option>
              </el-select>
              <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('form_problem_id')" />
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GetSellerList, PostChangeProcessMethod, PostCustomerReverseStatus, PostSellerListExport, GetSellerListProblemList, PostSellerListEdit, EditShop, GetSellerListCustomerList, BatchCheck, GetSellerUserList } from '../../api/sellerList'
export default {
  props: {
    processing_method: {
      type: Number,
      default: 0
    }
  },
  data () {
    var validate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入转单号'))
      }
      if ('' + value.length > 40) {
        return callback(new Error('超出最大输入长度40位'))
      }
      callback()
    }
    return {
      visible: false,
      selectionData: [],
      userInfo: JSON.parse(localStorage.getItem('user_info')),
      copyText: '',
      copyCustomerText: '',
      copySkuText: '',
      loading: false,
      dialogTitle: '修改问题件',
      dialogVisible: false,
      page: 1,
      limit: 200,
      count: 0,
      contract: false,
      form: {},
      searchForm: {
        customer_id: '',
        status: '',
        problem_id: '',
        order_number: '',
        start_cost_time: '',
        end_cost_time: '',
        start_create_time: '',
        end_create_time: '',
        shop_name: '',
        create_uid: '',
        claim_uid: ''
      },
      tableHeaderList: [
        { label: '转单号', status: true },
        { label: '订单号', status: true },
        { label: '渠道转单号', status: false },
        { label: '状态', status: false },
        { label: '问题类型', status: false },
        { label: '有新留言', status: false },
        { label: '最新留言内容', status: true },
        { label: '留言时间', status: true },
        { label: '客户账号', status: true },
        { label: '创建人', status: true },
        { label: '卖家认领人', status: true },
        { label: '创建时间', status: true },
        { label: '附加费用', status: false },
        { label: '附加费用说明', status: false },
        { label: '分类', status: false },
        { label: '店铺', status: true },
        { label: '型号', status: false }
      ],
      processMethodList: [
        { label: '待取', value: 4 },
        { label: '改派', value: 5 },
        { label: '退仓', value: 1 },
        { label: '赔偿', value: 3 },
        { label: '销毁', value: 2 }
      ],
      status: [
        { label: '请选择', value: '' },
        { label: '新建', value: 1 },
        { label: '处理中', value: 2 },
        { label: '已结单', value: 3 }
      ],
      problemList: [],
      customerList: [],
      userList: [],
      tableData: [],
      rules: {
        customer_order_number: [
          { max: 40, message: '超出最大输入限制40位', trigger: 'blur' }
        ],
        shop_name: [
          { max: 1020, message: '超出最大输入限制1020位', trigger: 'blur' }
        ],
        order_number: [
          { required: true, validator: validate, trigger: 'blur' }
        ],
        channel_order_number: [
          { max: 40, message: '超出最大输入限制40位', trigger: 'blur' }
        ],
        processing_method: [
          { required: true, message: '请选择处理方案', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    checkList: {
      get () {
        return this.tableHeaderList.filter(v => v.status).map(v => v.label)
      },
      set (newVal) {
        for (let i = 0; i < this.tableHeaderList.length; i++) {
          this.tableHeaderList.status = newVal
        }
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const { page, limit } = this
      const params = {
        page,
        limit,
        ...this.searchForm
      }
      if (this.processing_method) {
        params.processing_method = this.processing_method
      } else {
        params.processing_method = ''
      }
      this.loading = true
      if (this.userInfo.roles !== 3) {
        params.customer_id = ''
      } else {
        await GetSellerListCustomerList().then(res => {
          if (res && res.data.length) {
            this.customerList = res.data
            this.customerList.splice(0, 0, { id: '', firm_name: '请选择', is_show: 1 })
          }
        })
      }
      params.order_number = params.order_number.replace(/\n/g, ',')
      await GetSellerListProblemList().then(res => {
        if (res && res.data.length) {
          this.problemList = res.data
          this.problemList.splice(0, 0, { id: '', problem_type: '请选择' })
        }
      })
      // 获取该公司下所有用户
      await GetSellerUserList().then(res => {
        if (res && res.data.length) {
          this.userList = res.data
          this.userList.splice(0, 0, { id: '', nick_name: '请选择' })
        }
      })
      console.log(params)
      await GetSellerList(params).then(res => {
        if (res) {
          const { count, data } = res
          this.tableData = data
          this.count = count
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleUpt (row) {
      this.form = { ...row }
      this.dialogTitle = '修改问题件'
      this.dialogVisible = true
    },
    toMsg (row) {
      console.log(row)
      this.handleMessage(row)
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = null
          let params = {}
          if (this.dialogTitle === '修改问题件') {
            url = PostSellerListEdit
            params = { ...this.form }
          } else if (this.dialogTitle === '转批量') {
            url = PostChangeProcessMethod
            params = {
              order_id: this.selectionData.map(v => v.id),
              processing_method: this.form.processing_method
            }
          } else {
            url = EditShop
            params = {
              order_id: this.selectionData.map(v => v.id),
              shop_name: this.form.shop_name
            }
          }
          console.log(this.dialogTitle, url)
          url(params).then(res => {
            if (res) {
              this.$message.success(res.msg)
              this.dialogVisible = false
              this.init()
            }
          })
        }
      })
    },
    handleOver (row) {
      PostCustomerReverseStatus({ order_id: row.id }).then(res => {
        if (res) {
          this.$message.success(res.msg)
          this.init()
        }
      })
    },
    exportData () {
      if (!this.selectionData.length) {
        return this.$message.warning('请先选择数据')
      }
      PostSellerListExport({ order_id: this.selectionData.map(v => v.id) }).then(res => {
        if (res) {
          this.$message.success(res.msg)
        }
      })
    },
    handleMessage (row) {
      const data = {
        order_id: row.id,
        type: '卖家'
      }
      localStorage.setItem('messageData', JSON.stringify(data))
      const routeData = this.$router.resolve({ path: '/message' })
      console.log(routeData)
      window.open(routeData.href, '_blank')
      // this.$router.push('/message')
    },
    handleTurnTo (row) {
      window.open(`http://www.19track.net/index.html?order_number=${row.order_number}`)
    },
    reHandle () {
      if (!this.selectionData.length) {
        return this.$message.warning('请先选择数据')
      }
      this.dialogTitle = '转批量'
      this.dialogVisible = true
    },
    editShop () {
      if (!this.selectionData.length) {
        return this.$message.warning('请先选择数据')
      }
      this.dialogTitle = '修改商店'
      this.dialogVisible = true
    },
    batchCheck () {
      if (!this.selectionData.length) {
        return this.$message.warning('请先选择数据')
      }
      this.$confirm('结单后如需撤回，请联系管理员，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          order_id: this.selectionData.map(v => v.id)
        }
        BatchCheck(params).then(res => {
          if (res) {
            this.$message.success(res.msg)
            this.init()
          }
        })
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (this.userInfo.roles === 3) {
        if (row.unreply_num >= 1) {
          return 'high-light-row'
        }
      } else {
        if (row.customer_unreply_num >= 1) {
          return 'high-light-row'
        }
      }
    },
    handleChangeCheckBox (value, e) {
      for (let i = 0; i < this.tableHeaderList.length; i++) {
        if (this.tableHeaderList[i].label === e.target.defaultValue) {
          this.tableHeaderList[i].status = value
        }
      }
    },
    handleFouceSelect (val) {
      if (val.includes('time')) {
        this.$refs[val].focus()
      }
      document.getElementById(val).click()
    },
    // 点击行切换选中状态
    handleRowClick (row) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取表格多选框选中内容,用于复制单号
    handleSelectionChange (selection) {
      this.selectionData = selection
      this.copyText = selection.map(v => v.order_number).join('\n')
      this.copyCustomerText = selection.map(v => v.customer_order_number).join('\n')
      this.copySkuText = selection.map(v => v.sku).join('\n')
    },
    copyLink () {
      if (!this.selectionData.length) {
        return
      }
      const that = this
      const clipboard = new this.$clipboard('.copy-btn')
      clipboard.on('success', function () {
        that.$message.success('复制成功')
        if (clipboard) {
          clipboard.destroy()
        }
      })
      clipboard.on('error', function () {
        that.$message.error('复制失败')
      })
    },
    copyCustomer () {
      const that = this
      if (!this.selectionData.length) {
        return
      }
      if (this.copyCustomerText === '') {
        that.$message.error('订单号为空，复制失败')
        return
      }
      const clipboard = new this.$clipboard('.copy-cus')
      clipboard.on('success', function () {
        that.$message.success('复制成功')
        // console.log(clipboard)
        if (clipboard) {
          clipboard.destroy()
        }
      })
      clipboard.on('error', function () {
        that.$message.error('复制失败')
      })
    },
    copySku () {
      const that = this
      if (!this.selectionData.length) {
        return
      }
      if (this.copySkuText === '') {
        that.$message.error('sku为空，复制失败')
        return
      }
      const clipboard = new this.$clipboard('.copy-sku')
      clipboard.on('success', function () {
        that.$message.success('复制成功')
        // console.log(clipboard)
        if (clipboard) {
          clipboard.destroy()
        }
      })
      clipboard.on('error', function () {
        that.$message.error('复制失败')
      })
    },
    resetSearch () {
      Object.assign(this.$data.searchForm, this.$options.data().searchForm)
      this.init()
    },
    handleClose () {
      this.form = {}
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    handleContract () {
      this.contract = !this.contract
    },
    handleSizeChange (val) {
      this.limit = val
      this.init()
    },
    handleCurrentChange (val) {
      this.page = val
      this.init()
    }
  }
}
</script>

<style lang="less">
.seller-list {
  height: calc(100% - 110px);
  margin: 30px 20px 20px 20px;
  display: flex;
  .el-table__fixed-right {
    th {
      // border-top: 0;
      // border-bottom: 0;
      border-left: 1px solid #ccccd8;
    }
    td {
      // border-top: 1px solid #ccccd8;
      border-left: 1px solid #ccccd8;
      // border-bottom: 0;
    }
  }
  .el-table__fixed-body-wrapper {
    top: 35px !important;
  }
  .el-dialog__header {
    padding: 0;
    padding-top: 10px;
    .el-divider__text {
      color: #02044A;
      font-size: 22px;
      padding: 0 15px;
    }
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    padding-bottom: 40px;
    .el-button {
      padding: 12px 60px;
      font-size: 18px;
      letter-spacing: 4px;
    }
    .el-button+.el-button {
      margin-left: 40px;
    }
    .el-button--primary {
      background: #0C75FF;
    }
    .el-button--default {
      background: #DDDDDD;
      color: #676767;
    }
  }
  .seller-list-left {
    width: 220px;
    margin-right: 10px;
    background: #fff;
    box-shadow: 0px 1px 6px 1px rgba(34, 82, 177, 0.07);
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    & > .el-button {
      width: 150px;
      background: #0397BC;
      height: 40px;
      letter-spacing: 4px;
      padding: 10px 0;
      margin-top: 5px;
    }
    .el-button + .el-button {
      margin-left: 0;
      background-color: rgb(255, 225, 144);
      color: #6e6f95;
    }
    .seller-list-searchForm {
      display: flex;
      flex-direction: column;
      margin-bottom: 9px;
      .searchForm-span {
        color: #6e6f95;
        font-size: 12px;
        margin-bottom: 8px;
      }
      .diy-suffix {
        position: relative;
        .diy-suffix-icon {
          position: absolute;
          right: 7px;
          top: 6px;
          cursor: pointer;
        }
      }
      .el-input__suffix {
        display: none;
      }
      .el-input__inner {
        width: 198px;
        height: 30px;
      }
      .el-date-editor {
        width: 198px;
        margin-bottom: 5px;
        .el-input__inner {
          padding: 0 15px;
        }
        .el-input__prefix {
          display: none;
        }
      }
    }
  }
  .seller-list-right {
    width: calc(100% - 230px);
    background: #fff;
    box-shadow: 0px 1px 6px 1px rgba(34, 82, 177, 0.07);
    padding: 15px 12px;
    .high-light-row td{
      color: #00acd3 !important;
    }
    .seller-list-right-top {
      height: 40px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      .seller-list-icon {
        display: inline-block;
        width: 40px;
        height: 40px;
      }
      .seller-list-open-btn {
        background-size: 100% 100%;
        margin-right: 10px;
      }
      .seller-list-screen-btn {
        background: url("../../assets/img/screen-noselect-btn.png") no-repeat;
        background-size: 100% 100%;
      }
      .seller-list-rt-btnList {
        display: flex;
        align-items: center;
        .el-button {
          height: 40px;
          padding: 10px 15px;
          margin: 0 5px;
          font-size: 16px;
          &:nth-child(2) {
            background-color:#92CDDB;
            border-color:#92CDDB;
          }
          &:nth-child(3) {
            background-color:#47b5da;
            border-color:#47b5da;
          }
          &:nth-child(4) {
            background-color:#0397BC;
            border-color: #0397BC;
          }
          &:nth-child(5) {
            background-color:#8FB98A;
            border-color: #8FB98A;
          }
          &:nth-child(6) {
            background-color:#5F8778;
            border-color: #5F8778;
          }
          &:nth-child(7) {
            background-color:#79895f;
            border-color: #79895f;
          }
          &:nth-child(8) {
            background-color:#cbd565;
            border-color: #cbd565;
          }
        }
      }
    }
    .seller-list-right-table {
      width: 100%;
      height: calc(100% - 94px);
      overflow: hidden;
      margin-bottom: 10px;
      .el-table {
        height: 100%;
        border-color: #ccccd8;
        th {
          color: #02044a;
          background: #E9EFF1;
          border-color: #ccccd8;
          font-weight: normal;
        }
        td {
          color: #74758f;
          border-color: #ccccd8;
        }
        .el-table-column--selection .cell {
          padding-right: 10px;
        }
      }
    }
    .gongneng-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background-size: 100% 100%;
      transform: translateY(3px);
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
    }
    .car-icon {
      background-image: url("../../assets/img/car.png");
    }
    .message-icon {
      background-image: url("../../assets/img/message.png");
    }
    .edit-icon {
      background-image: url("../../assets/img/edit.png");
    }
    .withdraw-icon {
      background-image: url("../../assets/img/withdraw.png");
    }
    .el-form {
      .el-form-item {
        width: 100%;
        border: 1px solid #DDDDE6;
        border-radius: 4px;
        .el-input__inner {
          border: 0;
        }
        .el-input {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
        &:nth-child(2n) {
          margin-right: 0;
        }
        .el-form-item__label {
          border: 0;
          background: #f0f1f4;
          color: #6e6f95;
          font-size: 14px;
          text-align: center;
          padding-right: 0;
          height: 41px;
          border-right: 1px solid #DDDDE6;
        }
      }
      .el-input__suffix {
        display: none;
      }
      .diy-suffix {
        position: relative;
        .diy-suffix-icon {
          position: absolute;
          right: 7px;
          top: 2px;
          cursor: pointer;
        }
      }
    }
    .el-pagination__total {
      margin-left: 10px;
    }
  }
}
</style>
